const PARTNERS_URL = process.env.GATSBY_PARTNERS_URL;
const API_URL = process.env.GATSBY_API_URL;

const apiEndpoints = {
  API_URL,
  PARTNERS_URL
}

export default apiEndpoints;
